import { lazy } from 'react';

export const SendAffiliate = lazy(() => import('./SendAffiliateRequest.component'));
